export const Work = [
    {
        id:1,
        name:"Community Website",
        description:"A Website Developed for College Communities and Groups for Posting Event Related Posts. The users following the committee can like, and comment on the post.",
        tags:["NextJs","Recoil","Chakra UI","Firebase"],
        
        demo:"https://community-as48.vercel.app/",
        github:"https://github.com/777ahesh/community"
        
    },
    {
        id:2,
        name:"Frontend Clone Projects",
        description:"It is build on top of the React JS, with styledComponents and GSAP for smooth scrolling animations.",
        tags:["react","HTML","CSS","JavaScript","styledComponents"],
        
        demo:"/frontendclone",
        github:"https://github.com/777ahesh/frontendclone/"
    },
    {
        id:3,
        name:"E-Commerce Dashboard",
        description:"React Js E-Commerce Dashboard using Some Frontend Libraries",
        tags:["ReactJs","React-Charts","JavaScript"],
        
        demo:"https://777ahesh.github.io/react-ecommerce-app/",
        github:"https://github.com/777ahesh/react-ecommerce-app"
            
    },
    {
        id:4,
        name:"Dev Talks",
        description:"A website were you can see all the latest  Dev.to articles. With realtime fetching of articles from dev.to using API.",
        tags:["react","api","sass"],
        
        demo:"https://dev-talks-latest.netlify.app/",
        github:"https://github.com/777ahesh/Dev-Talks"
    },
    {
        id:5,
        name:"Vscode Theme",
        description:"Night Cyan is a cool Vscode Dark Theme",
        tags:["react","styledComponents","react-router"],
        
        demo:"https://marketplace.visualstudio.com/items?itemName=MaheshGaikwad.night-cyan",
        github:"https://marketplace.visualstudio.com/items?itemName=MaheshGaikwad.night-cyan"
       
    },
    {
        id:6,
        name:"Restaurant Automation",
        description:"A Restaurant Automation Platform build using MERN Stack During my Internship Period in (SortWind Pvt. Ltd.) ",
        tags:["react","redux","express","mongodb","react libraries"],
        
        demo:"/",
        github:"https://github.com/777ahesh/"
        
    },    
  
] 